'use client';

import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

import { SloganSvg } from './SloganSvg';

const CONTAINER_ANIMATION = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.1,
    },
  },
};

const ITEM_ANIMATION = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

export const ProgramIntroSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-50px' });

  return (
    <section className="relative bg-Gray-black px-32 py-80 flex-center">
      <motion.svg
        width="83"
        height="82"
        viewBox="0 0 83 82"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute -top-41 right-30"
        animate={{
          y: [0, -10, 0],
        }}
        transition={{
          duration: 2.5,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      >
        <path
          d="M1.58725 52.2052C7.84707 73.9575 30.7854 86.6217 52.8457 80.428C74.8648 74.246 87.6706 51.543 81.4128 29.7907C75.1529 8.03838 52.1735 -4.61417 30.1543 1.56786C8.13517 7.75183 -4.67062 30.4529 1.58725 52.2071"
          fill="#1C9CFF"
        />
      </motion.svg>

      <motion.div
        ref={ref}
        variants={CONTAINER_ANIMATION}
        initial="hidden"
        animate={isInView ? 'visible' : 'hidden'}
        className="flex w-full flex-col gap-32"
      >
        <div className="flex flex-col gap-20">
          <motion.svg
            variants={ITEM_ANIMATION}
            width="120"
            height="31"
            viewBox="0 0 120 31"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clipPath="url(#clip0_17759_497)">
              <path
                d="M101.469 28.7023L102.045 28.1967C103.021 27.3452 103.668 26.8043 103.668 25.837C103.668 24.7637 102.861 23.8232 101.459 23.8232C100.057 23.8232 99.0994 24.7016 99.0472 26.1025H100.564C100.626 25.5433 100.875 25.2594 101.389 25.2594C101.956 25.2594 102.143 25.6054 102.143 25.9062C102.143 26.279 101.956 26.4654 100.794 27.485L98.9766 29.0723V30.1455H103.784V28.7094H101.451L101.469 28.7009V28.7023Z"
                fill="#535861"
              />
              <path
                d="M106.929 23.8232C105.209 23.8232 104.18 25.1097 104.18 27.043C104.18 28.9763 105.209 30.2628 106.929 30.2628C108.649 30.2628 109.679 28.9763 109.679 27.043C109.679 25.1097 108.651 23.8232 106.929 23.8232ZM106.929 28.8252C106.051 28.8252 105.705 28.1869 105.705 27.043C105.705 25.8991 106.051 25.2608 106.929 25.2608C107.808 25.2608 108.154 25.8991 108.154 27.043C108.154 28.1869 107.808 28.8252 106.929 28.8252Z"
                fill="#535861"
              />
              <path
                d="M112.481 28.7023L113.057 28.1967C114.033 27.3452 114.68 26.8043 114.68 25.837C114.68 24.7637 113.873 23.8232 112.471 23.8232C111.069 23.8232 110.111 24.7016 110.059 26.1025H111.576C111.638 25.5433 111.886 25.2594 112.4 25.2594C112.968 25.2594 113.154 25.6054 113.154 25.9062C113.154 26.279 112.968 26.4654 111.806 27.485L109.988 29.0723V30.1455H114.795V28.7094H112.462L112.481 28.7009V28.7023Z"
                fill="#535861"
              />
              <path
                d="M118.033 25.9443C117.66 25.9443 117.376 26.0333 117.155 26.1575L117.314 25.3766H119.797V23.9404H116.179L115.408 27.5683H116.844C116.95 27.4003 117.234 27.187 117.677 27.187C118.201 27.187 118.564 27.4892 118.564 27.9934C118.564 28.4721 118.226 28.8364 117.65 28.8364C117.234 28.8364 116.817 28.6416 116.763 28.1007H115.238C115.292 29.6089 116.48 30.2641 117.669 30.2641C119.043 30.2641 120.091 29.4211 120.091 28.0117C120.091 26.6024 119.115 25.9457 118.033 25.9457V25.9443Z"
                fill="#535861"
              />
              <path
                d="M102.218 18.2217H85.9102V21.1915H102.218V18.2217Z"
                fill="#535861"
              />
              <path
                d="M94.064 10.7792L98.1551 17.1283H102.218L96.2501 8.27261L96.2261 8.2373H91.9034L85.9102 17.1283H89.9744L94.064 10.7792Z"
                fill="#535861"
              />
              <path
                d="M118.63 12.5388V7.87012H115.105V21.4693H118.63V15.7868H120.089V12.5388H118.63Z"
                fill="#535861"
              />
              <path
                d="M78.0584 12.6369H76.3906V15.69H78.0584V21.3345H81.0282V8.00781H78.0584V12.6369Z"
                fill="#535861"
              />
              <path
                d="M76.0018 11.2765H76.8491V8.43945H68.6133V11.2765H69.4606V18.3261H68.6133V20.9005H76.8491V18.3261H76.0018V11.2765ZM73.0461 18.3261H72.4177V11.2765H73.0461V18.3261Z"
                fill="#535861"
              />
              <path
                d="M84.7176 8.00781H81.6094V21.3345H84.7176V8.00781Z"
                fill="#535861"
              />
              <path
                d="M114.226 18.2229H107.071V15.7177H114.226V12.8863H107.071V11.1168H114.226V8.14844H103.574V21.1913H114.226V18.2229Z"
                fill="#535861"
              />
              <path
                d="M61.4461 9.90858H63.4105V12.3403H66.787V5.21875H63.4105V7.42739H61.4476V5.49836H51.4621V7.46269H58.1007V8.02756H51.4621V9.88033H58.1007V10.4593H51.1133V12.3403H58.5314C60.3545 12.3403 61.3868 11.4775 61.4476 9.90858H61.4461Z"
                fill="#535861"
              />
              <path
                d="M46.4644 8.74377H34.7631V14.3162H49.9849V11.8167H38.2159V11.2419H49.9171V5.68359H34.6953V8.18314H46.4644V8.74377Z"
                fill="#535861"
              />
              <path
                d="M55.184 16.546H66.7836V12.7656H51.7383V14.4786H63.4071V14.8754H51.8089V18.7264H66.8528V16.9301H55.184V16.546Z"
                fill="#535861"
              />
              <path
                d="M44.132 14.7441H40.6792V16.2255H34.4219V18.8635H50.3907V16.2255H44.132V14.7441Z"
                fill="#535861"
              />
              <path
                d="M29.23 11.4074H17.5287V16.9798H32.7491V14.4803H20.9815V13.9055H32.6813V8.34863H17.4609V10.8468H29.23V11.4074Z"
                fill="#535861"
              />
              <path
                d="M26.9029 17.4082H23.4502V18.8896H17.1914V21.5289H33.1603V18.8896H26.9029V17.4082Z"
                fill="#535861"
              />
              <path
                d="M15.9066 8.15527H12.9453V14.7671H15.9066V8.15527Z"
                fill="#535861"
              />
              <path
                d="M9.65769 14.7671H12.5569V8.15527H9.65769V9.63806H8.57031V12.002H9.65769V14.7671Z"
                fill="#535861"
              />
              <path
                d="M4.40598 19.287H15.9011V15.3173H5.87464V14.3952H8.87833V12.6681H6.13448C6.53271 12.582 6.88293 12.4647 7.18231 12.3151C8.02538 11.8956 8.45327 11.239 8.45327 10.3663C8.45327 9.49353 8.02538 8.84817 7.18231 8.43017C6.48046 8.08277 5.50465 7.90625 4.28453 7.90625C3.06442 7.90625 2.07872 8.08277 1.37546 8.43017C0.529565 8.84817 0.100264 9.50059 0.100264 10.3677C0.100264 11.2347 0.528153 11.8971 1.37263 12.3165C1.67343 12.4662 2.02364 12.5834 2.42329 12.6695H0V14.3966H2.97969V15.3187H0.951805V17.1447H12.5161V17.4709H1.021V21.5309H15.9703V19.6188H4.40598V19.2898V19.287ZM4.28312 10.7786C2.97969 10.7786 2.97969 10.5781 2.97969 10.3648C2.97969 10.1516 2.97969 9.96943 4.28312 9.96943C5.58656 9.96943 5.57385 10.1615 5.57385 10.3648C5.57385 10.5682 5.57385 10.7786 4.28312 10.7786Z"
                fill="#535861"
              />
            </g>
            <defs>
              <clipPath id="clip0_17759_497">
                <rect width="120" height="30.2609" fill="white" />
              </clipPath>
            </defs>
          </motion.svg>

          <div className="flex w-full justify-center">
            <SloganSvg
              className="h-auto w-full"
              style={{ aspectRatio: '262 / 70.88' }}
            />
          </div>
        </div>

        <div className="flex flex-col gap-16 font-400 text-Gray-550 typo-body3">
          <motion.p variants={ITEM_ANIMATION}>
            지역 균형발전을 돕는
            <br />
            거브테크(Gov-Tech) 기업 웰로가
            <br />
            열 곳의 지역과 함께
            <br />
            &apos;웰로 로컬페스타&apos;를 처음 개최합니다.
          </motion.p>

          <motion.p variants={ITEM_ANIMATION}>
            정책은 손으로 직접 느끼고,
            <br />
            마음으로 공감할 때 비로소 반응합니다.
          </motion.p>

          <motion.p variants={ITEM_ANIMATION}>
            고향의 가치와 로컬의 가능성을
            <br />
            오프라인에서 직접 경험하고 연결되는 시간
            <br />
            &apos;웰로 로컬페스타 2025&apos;에서 만나보세요.
          </motion.p>

          <motion.p variants={ITEM_ANIMATION}>
            지속가능한 지역의 미래,
            <br />
            웰로가 함께 만들어갑니다.
          </motion.p>
        </div>
      </motion.div>
    </section>
  );
};
